module.exports = __webpack_public_path__ + "static/img/new_gift_modal.55a3f2b0.png";